export default function getAppliedFilterText(appliedFilters, variant = 'button') {
  const count = appliedFilters.length;
  if (count === 0) return '';
  if (variant === 'pill') {
    return ` (${count})`;
  }
  return (count > 1) ? `: (${count})` : `: ${appliedFilters[0]}`;
}
